import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { parseJSON } from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';

declare let window;

@Component({
  selector: 'deposit-paylado-result.component',
  templateUrl: '../sharedTemplates/deposit-paylado-result.component.html',
})
export class DepositPayladoResultComponent {
  coinbaseDatas: UntypedFormGroup;
  coinbaseDataRaw: any;
  firststep = true;
  statu = '0';
  token: any;
  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    this.coinbaseDatas = _FormBuilder.group({
      amount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5), Validators.max(10000)]),
    });
  }

  ngAfterViewInit() {
    // this._UiHelper.setNavbarTitle('CreditCard', true);

    this.token = new URLSearchParams(window.location.search).getAll('Token')[0];
    // console.warn("this.token1",this.token)
    if (this.token.length > 0) {
      // console.warn("this.token2",this.token)

      if (window.self !== window.top) {
        // checking if it is an iframe
        window.parent.location.href = '/depositpayladoresult?Token=' + this.token;
      }

      this.confirmPaylado();
    }
  }
  confirmPaylado() {
    this._ApiService.confirmPaylado(this.token).then(result => {
      const translator = new TranslatePipe(this._LocalizationService);

      const apcoresult = JSON.parse(result);

      ////console.warn( apcoresult.result);
      if (apcoresult.result == 'success') {
        this.statu = '1';
        if (this._UserHelper.customerUser.CustomerId) {
          this._ApiService.getClient2().then().catch();
        }
      } else {
        this.statu = '2';

        this._UiHelper.errorSnackBar(apcoresult.desc, '');
      }
    });
  }
}
